import React from 'react';
import { SmsAuth } from '@/components/auth/SmsAuth';

const SmsLoginPage = () => {
  const handleAuthSuccess = () => {
    // Redirect handled by SmsAuth component
    window.location.reload();
  };

  return <SmsAuth onAuthSuccess={handleAuthSuccess} />;
};

export default SmsLoginPage;